// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:d40b0f54-eb88-41af-9265-fbd763b76aad",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_o2vzbm1lU",
    "aws_user_pools_web_client_id": "78m7eamk75fkucjfon92hm2d93",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://jfl4zb7k2rgjxd47ek3kdfuwn4.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "appvenwebapi",
            "endpoint": "https://l73tpztd71.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "og3filesbucket",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_content_delivery_bucket": "appventorywebhostingbucket",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "http://appventorywebhostingbucket.s3-website-us-east-1.amazonaws.com",
    "aws_mobile_analytics_app_id": "d1b9d9914fb342f2a069ce1e488e35b5",
    "aws_mobile_analytics_app_region": "us-east-1"
};


export default awsmobile;
